import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBriefcase,
  faHandshake,
  faLightbulb,
  faLocationDot,
  faUserGroup,
  faUserShield
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backgroundImage from '../Images/fundoteambuilding.png';
import '../CSS/Despedidas.css';

const TeamBuildings = () => {
  return (
    <div className="er-partyPage">
      <section className="er-partyHero" aria-label="Team buildings">
        <img src={backgroundImage} alt="" className="er-partyHeroImg" />
        <div className="er-partyHeroOverlay">
          <div className="er-partyHeroInner">
            <div className="er-partyBadge">Cooperation • Strategy • Fun</div>

            <h1 className="er-partyTitle">
              Team <span className="er-partyTitleAccent">Buildings</span>
            </h1>

            <p className="er-partyLead">Strengthen your team!</p>
            <p className="er-partyText">
              Bring your team together for an immersive challenge that boosts communication, trust and problem-solving —
              with adrenaline and moments that reinforce team spirit.
            </p>

            <div className="er-partyCtas">
              <a
                className="er-partyCtaPrimary"
                href="https://wa.me/351934403133"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Talk to us
              </a>
            </div>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faHandshake} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Teamwork</h2>
              <p className="er-partyHeroCardText">
                Activities designed to strengthen cooperation from the very first minute.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLightbulb} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Strategy & creativity</h2>
              <p className="er-partyHeroCardText">
                Puzzles to test communication, leadership and problem-solving.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faBriefcase} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Real impact</h2>
              <p className="er-partyHeroCardText">
                A fun experience with takeaways that carry into everyday teamwork.
              </p>
            </article>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">For every team</h3>
              <p className="er-partyFeatureText">
                We adapt to your team size and goals.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLocationDot} className="er-partyFeatureIcon" />
              <h2 className="er-partyHeroCardTitle">Great location</h2>
              <p className="er-partyFeatureText">
                In the heart of Bragança — easy to reach and ideal for a company event.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserShield} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Dedicated team</h3>
              <p className="er-partyFeatureText">
                Support before, during and after the game so everything runs smoothly.
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamBuildings;
